<template>
  <div>
    <div class="card__header">
      <h3 v-if="TotalProducts > 0">
        <span class="type-regular type-bold"
          >Suggestions for you<span v-if="CommonTags.length > 0"
            >, based on</span
          >:</span
        >
        <br />
        <span class="type-regular">{{ formattedCommonTags }}</span>
      </h3>
      <h3 v-if="TotalProducts < 1">
        <span class="type-regular"
          >No suggested items. <br />Add something to your cart!</span
        >
      </h3>
    </div>

    <div
      v-for="product in SuggestedProducts"
      v-if="SuggestedProducts.length > 0"
      class="card__section suggested__details flex flex--between card__section--border-bottom"
    >
      <div class="suggested__img">
        <img
          class="img-thumbnail-box-shadow"
          :src="productImage(product)"
          alt=""
        />
      </div>
      <div class="suggested__info">
        <h5 class="type-h5">
          <a :href="getProductHref(product)" class="type-link no-underline">{{
            product.Name
          }}</a>
        </h5>
        <p class="type-x-small">Scripts, {{ product.Edition }}</p>
        <button
          class="btn btn--tertiary btn--small bg-color-silver-lightest"
          @click="addItemToCart(product.ProductVariantId)"
        >
          Add to Cart
        </button>
      </div>
      <div class="suggested__price">
        <span class="type-x-small type-bold">{{ product.Price }}</span>
      </div>
    </div>
    <div
      class="card__section suggested__details align-center bg-color-white"
      v-if="SuggestedProducts.length < 1 && TotalProducts > 0"
    >
      <loading />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import { FETCH_RELATED_CART_ITEMS } from "../vuex/modules/cart/mutations";
import { SET_SUGGESTED_PRODUCT_PRICES } from "../vuex/modules/cart/mutations";
import { POST_CART_ITEM } from "../vuex/modules/cart/mutations";
import { UPDATE_AFTER_ADD_OR_DELETE } from "../vuex/modules/cart/mutations";

import Loading from "./Loading.vue";

export default {
  name: "CartSuggested",
  components: {
    Loading,
  },
  data() {
    return {
      LocalTags: [],
      cartTrigger: null,
      miniCart: null,
      mainContent: null,
    };
  },

  mounted() {
    this.cartTrigger = document.getElementById("cart-trigger");
    this.mainContent = document.getElementById("main-content");
  },

  watch: {
    allProductsLoaded(val) {
      if (val >= this.Items.length) {
        const commonTags = this.getCommonTags();
        const $vm = this;
        this.FETCH_RELATED_CART_ITEMS(commonTags).then(function() {
          // $vm.getProductPrices();
        });
      }
    },
  },

  methods: {
    ...mapActions({
      FETCH_RELATED_CART_ITEMS,
      SET_SUGGESTED_PRODUCT_PRICES,
      POST_CART_ITEM,
      UPDATE_AFTER_ADD_OR_DELETE,
    }),

    getProductPrices() {
      this.SET_SUGGESTED_PRODUCT_PRICES();
    },

    getProductHref(product) {
      return `${window.env.APP_URL}s/${product.Id}/${product.SeName}/`;
    },

    getCommonTags() {
      const uniqueTags = [];
      const commonTags = [];
      this.Tags.forEach((item) => {
        if (!uniqueTags.includes(item)) {
          uniqueTags.push(item);
        } else {
          if (!commonTags.includes(item)) {
            commonTags.push(item);
          }
        }
      });

      return commonTags; //console.log(commonTags);
    },

    /*
     * Calls action for post request to add new items to the cart.
     */
    addItemToCart(variantId) {
      // console.log(variantId);
      const $vm = this;
      this.POST_CART_ITEM({ productVariantId: variantId, quantity: 1 }).then(
        function() {
          $vm.openMiniCart();
          $vm.UPDATE_AFTER_ADD_OR_DELETE();
        }
      );
    },

    /*
     * TODO - potential for refactor. Can we move this logic out from
     * a separate JS file and into a Vue component?  This is dirty.
     *
     * Update Feb 27 - toggle moved to vuex store, can still be better.
     * Move the dropdown overlay method into mutations (in cart store)
     */
    openMiniCart() {
      this.$store.commit("toggleMiniCart", true);
      this.mainContent.classList.add("js-dropdown-open");
      this.cartTrigger.focus();
    },

    productImage(product) {
      // console.log({product});
      const image = product.ProductImages.find((item) => item.Height == 300);
      return image.ImageUrl;
    },
  },

  computed: {
    ...mapState({
      Items: (state) => state.cartStore.Items,
      Tags: (state) => state.cartStore.Tags,
      allProductsLoaded: (state) => state.cartStore.allProductsLoaded,
      SuggestedProducts: (state) => state.cartStore.SuggestedProducts,
      CommonTags: (state) => state.cartStore.CommonTags,
      TotalProducts: (state) => state.cartStore.TotalProducts,
    }),
    ...mapGetters(["formattedCommonTags"]),
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CartSuggested.vue